import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'

import store from '@/state/store'
import routes from './routes'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import LogRocket from 'logrocket';
LogRocket.init('gw4sfv/kali');

Vue.use(VueRouter)
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page',
})
Vue.component('v-select', vSelect)


const router = new VueRouter({
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {
  if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {

    // Check if auth is required on this route
    // (including nested routes).
    const authRequired = routeTo.matched.some((route) => route.meta.authRequired)
    // const adminAccess = routeTo.matched.some((route) => route.meta.adminAccess)
    const mechanicAccess = routeTo.matched.some((route) => route.meta.mechanicAccess)
    const supervisorAccess = routeTo.matched.some((route) => route.meta.supervisorAccess)


    // If auth isn't required for the route, just continue.
    if (!authRequired) return next()

    if (store.getters['auth/loggedIn']) { 

      // Validate the local user token... Check if they are an admin user.
      return store.dispatch('auth/getAccessLevels').then((adminUser) => {
        // Then continue if the token still represents a valid user,
        // otherwise redirect to login.
        if(adminUser.includes('Admin')){ //admin users can access every page.
          next();
        }else{
          //this is not an admin user. Do additional privledge checks.
          if(supervisorAccess && adminUser.includes('Supervisor')){
            // Then continue if the token still represents a valid user,
            // otherwise redirect to login.
            adminUser ? next() : redirectToLogin()
          }
          else if(mechanicAccess && adminUser.includes('Mechanic')){
            // Then continue if the token still represents a valid user,
            // otherwise redirect to login.
            adminUser ? next() : redirectToLogin()
          }else{
            redirectToLogin();
          }
        }
        // validUser ? next() : redirectToLogin()
      })
        
      // else{
      //   // Validate the local user token...
      //   return store.dispatch('auth/getAccessLevels').then((validUser) => {
      //     if(mechanicAccess && validUser.includes('Mechanic')){
      //       // Then continue if the token still represents a valid user,
      //       // otherwise redirect to login.
      //       validUser ? next() : redirectToLogin()
      //     }
      //   })
      // }
      
    }


    // If auth is required and the user is logged in...
    // if (store.getters['auth/loggedIn']) { 

      
    //   if(adminAccess){ //admin users can access every page.
    //     // Validate the local user token... Check if they are an admin user.
    //     return store.dispatch('auth/validate').then((validUser) => {
    //       // Then continue if the token still represents a valid user,
    //       // otherwise redirect to login.
    //       validUser ? next() : redirectToLogin()
    //     })
    //   }
    //   else{
    //     // Validate the local user token...
    //     return store.dispatch('auth/getAccessLevels').then((validUser) => {
    //       if(mechanicAccess && validUser.includes('Mechanic')){
    //         // Then continue if the token still represents a valid user,
    //         // otherwise redirect to login.
    //         validUser ? next() : redirectToLogin()
    //       }
    //     })
    //   }
      
    // }
    // If auth is required and the user is NOT currently logged in,
    // redirect to login.
    redirectToLogin()

    // eslint-disable-next-line no-unused-vars
    // eslint-disable-next-line no-inner-declarations
    function redirectToLogin() {
      // Pass the original route to the login component
      
      next({ name: 'login', query: { redirectFrom: routeTo.fullPath, redirectFromName: routeTo.name, query: routeTo.query } })
    }
  } else {
    const publicPages = ['/login', '/register', '/forgot-password'];
    const authpage = !publicPages.includes(routeTo.path);
    const loggeduser = localStorage.getItem('user');

    if (authpage && !loggeduser) {
      return next('/login');
    }

    next();
  }
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => { //reject
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        // if (route.meta && route.meta.beforeResolve) {
        //   route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
        //     // If the user chose to redirect...
        //     if (args.length) {
        //       // If redirecting to the same route we're coming from...
        //       // Complete the redirect.
        //       next(...args)
        //       reject(new Error('Redirected'))
        //     } else {
        //       resolve()
        //     }
        //     resolve()
        //   })
        // } 
        // else {
          // Otherwise, continue resolving the route.
          // console.log(route)
          if(route.name == 'logout'){
              route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
              // If the user chose to redirect...
              if (args.length) {
                // If redirecting to the same route we're coming from...
                // Complete the redirect.
                next(...args)
                reject(new Error('Redirected'))
              } else {
                resolve()
              }
              resolve()
            })
          }else{
            resolve()
          }
        // }
      })
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return
  }

  // If we reach this point, continue resolving the route.
  next()
})

export default router
